import styled from "styled-components";
import { responsiveWidth } from "responsive";

export const SaleTogetherContainer = styled.div`
  ${responsiveWidth}

  @media (min-width: 1921px) {
    display: flex;
    flex-direction: row;
    gap: 33px;

    .images {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 548px;
      height: 538px;

      .main {
        background: #f2f1f0;
        border-radius: 16px;
        cursor: pointer;

        img {
          width: 548px;
          height: 538px;
          object-fit: contain;
        }
      }

      .sub {
        width: 100px;
        height: 104px;
        display: flex;
        flex-direction: row;
        gap: 12px;

        img {
          min-width: 100px;
          max-width: 100px;
          height: 104px;
          border-radius: 6px;
          cursor: pointer;
        }

        img.active {
          border: 2px solid #653cd5;
        }

        .no-img {
          min-width: 100px;
          height: 104px;
          border-radius: 6px;
          background: #f2f1f0;
        }
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      width: 100%;

      .content {
        .title {
          font-weight: 700;
          font-size: 24px;
          line-height: 38px;
          letter-spacing: -0.05em;
          height: 76px;
        }

        .price {
          padding-top: 52px;
          padding-bottom: 34px;
          display: flex;
          flex-direction: column;
          gap: 28px;
          height: 275px;

          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            font-weight: 700;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;
            align-items: center;

            .key {
              color: #5f5f5f;
            }

            .all-value {
              font-weight: 800;
              font-size: 26px;

              span {
                color: #653cd5;
              }
            }
          }

          .item-all {
            position: relative;

            .data {
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              font-weight: 700;
              font-size: 22px;
              line-height: 100%;
              letter-spacing: -0.05em;

              .key {
                color: #5f5f5f;
              }

              .all-value {
                font-weight: 800;
                font-size: 24px;

                span {
                  color: #653cd5;
                }
              }
            }

            .all {
              font-weight: 400;
              font-size: 14px;
              position: absolute;
              top: 20px;
              right: 0px;
              color: #727272;
            }
          }
        }
      }

      .line {
        border: 1px solid #000000;
      }

      .box-select {
        display: flex;
        flex-direction: column;
        gap: 6px;
        text-align: right;
        color: #5f5f5f;
        margin-top: 34px;

        .item-select {
          display: flex;
          flex-direction: row;
          gap: 14px;
          align-items: center;
          justify-content: end;

          .item-select-text {
            font-weight: 800;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }

          .item-select-qty {
            font-weight: 800;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }
        }

        .shinhan-text {
          font-weight: 700;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #959595;
        }
      }

      .box-total {
        display: flex;
        flex-direction: row;

        font-weight: 800;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: -0.05em;
        justify-content: right;
        color: #5f5f5f;
        margin-top: 16px;
        gap: 6px;
        align-items: center;

        .sub-total {
          font-weight: 700;
          font-size: 22px;
        }

        .price-total {
          font-size: 32px;
          color: #000000;
          margin-left: 30px;
          line-height: 100%;
        }
      }

      .timer {
        display: felx;
        flex-direction: column;
        display: flex;
        gap: 6px;
        text-align: center;

        font-weight: 700;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        margin-top: 25px;
        padding: 17px 0px;
        color: #5f5f5f;
        height: 73px;
        border-radius: 7px;
        background: #f7f7f7;

        .time-countdown {
          color: #653cd5;
        }

        .time-end {
          font-size: 14px;
          color: #959595;
          text-align: center;
        }
      }

      .btn {
        height: 52px;
        border-radius: 7px;
        background: #653cd5;

        font-weight: 800;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        margin-top: 12px;
        color: #ffffff;
        cursor: pointer;
      }

      .btn.disabled {
        background: #d9d9d9;
      }

      .info {
        font-weight: 700;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
        color: #f12d2d;
        margin-top: 12px;
        text-align: right;
      }
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 26px;

    .images {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 461px;
      height: 550px;

      .main {
        background: #f2f1f0;
        border-radius: 16px;
        cursor: pointer;

        img {
          width: 460px;
          height: 452px;
          object-fit: contain;
        }
      }

      .sub {
        width: 84px;
        height: 86px;
        display: flex;
        flex-direction: row;
        gap: 10px;

        img {
          min-width: 84px;
          max-width: 84px;
          height: 86px;
          border-radius: 5px;
          cursor: pointer;
        }

        img.active {
          border: 2px solid #653cd5;
        }

        .no-img {
          min-width: 84px;
          height: 86px;
          border-radius: 6px;
          background: #f2f1f0;
        }
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      width: 445px;

      .content {
        .title {
          font-weight: 700;
          font-size: 22px;
          line-height: 30px;
          letter-spacing: -0.05em;
          height: 60px;
        }

        .price {
          padding-top: 48px;
          padding-bottom: 30px;
          display: flex;
          flex-direction: column;
          gap: 24px;
          height: 235px;

          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            font-weight: 700;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -0.05em;
            align-items: center;

            .key {
              color: #5f5f5f;
            }

            .all-value {
              font-weight: 800;
              font-size: 22px;

              span {
                color: #653cd5;
              }
            }
          }

          .item-all {
            position: relative;

            .data {
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              font-weight: 700;
              font-size: 18px;
              line-height: 100%;
              letter-spacing: -0.05em;

              .key {
                color: #5f5f5f;
              }

              .all-value {
                font-weight: 800;
                font-size: 24px;

                span {
                  color: #653cd5;
                }
              }
            }

            .all {
              font-weight: 400;
              font-size: 12px;
              position: absolute;
              top: 18px;
              right: 0px;
              color: #727272;
            }
          }
        }
      }

      .line {
        border: 1px solid #000000;
      }

      .box-select {
        display: flex;
        flex-direction: column;
        gap: 5px;
        text-align: right;
        color: #5f5f5f;
        margin-top: 29px;

        .item-select {
          display: flex;
          flex-direction: row;
          gap: 12px;
          align-items: center;
          justify-content: end;

          .item-select-text {
            font-weight: 800;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }

          .item-select-qty {
            font-weight: 800;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }
        }

        .shinhan-text {
          font-weight: 700;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #959595;
        }
      }

      .box-total {
        display: flex;
        flex-direction: row;

        font-weight: 800;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: -0.05em;
        justify-content: right;
        color: #5f5f5f;
        margin-top: 12px;
        gap: 10px;
        align-items: center;

        .sub-total {
          font-weight: 700;
          font-size: 18px;
        }

        .price-total {
          font-size: 26px;
          color: #000000;
          margin-left: 25px;
          line-height: 100%;
        }
      }

      .timer {
        display: felx;
        flex-direction: column;
        display: flex;
        gap: 6px;
        text-align: center;

        font-weight: 700;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        margin-top: 21px;
        padding: 14px 0px;
        color: #5f5f5f;
        height: 61px;
        border-radius: 6px;
        background: #f7f7f7;

        .time-countdown {
          color: #653cd5;
        }

        .time-end {
          font-size: 14px;
          color: #959595;
          text-align: center;
        }
      }

      .btn {
        height: 44px;
        border-radius: 6px;
        background: #653cd5;

        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        margin-top: 10px;
        color: #ffffff;
        cursor: pointer;
      }

      .btn.disabled {
        background: #d9d9d9;
      }

      .info {
        font-weight: 700;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
        color: #f12d2d;
        margin-top: 12px;
        text-align: right;
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 23px;

    .images {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 397px;
      height: 474px;

      .main {
        background: #f2f1f0;
        border-radius: 14px;
        cursor: pointer;

        img {
          width: 397px;
          height: 389px;
          object-fit: contain;
        }
      }

      .sub {
        width: 72px;
        height: 74px;
        display: flex;
        flex-direction: row;
        gap: 9px;

        img {
          min-width: 72px;
          max-width: 72px;
          height: 74px;
          border-radius: 6px;
          cursor: pointer;
        }

        img.active {
          border: 2px solid #653cd5;
        }

        .no-img {
          min-width: 72px;
          height: 74px;
          border-radius: 6px;
          background: #f2f1f0;
        }
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      width: 381px;

      .content {
        .title {
          font-weight: 700;
          font-size: 20px;
          line-height: 27px;
          letter-spacing: -0.05em;
          height: 52px;
        }

        .price {
          padding-top: 40px;
          padding-bottom: 26px;
          display: flex;
          flex-direction: column;
          gap: 20px;
          height: 201px;

          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            letter-spacing: -0.05em;
            align-items: center;

            .key {
              color: #5f5f5f;
            }

            .all-value {
              font-weight: 400;
              font-size: 12px;

              span {
                color: #653cd5;
              }
            }
          }

          .item-all {
            position: relative;

            .data {
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              font-weight: 700;
              font-size: 16px;
              line-height: 100%;
              letter-spacing: -0.05em;

              .key {
                color: #5f5f5f;
              }

              .all-value {
                font-weight: 800;
                font-size: 18px;

                span {
                  color: #653cd5;
                }
              }
            }

            .all {
              font-weight: 400;
              font-size: 12px;
              position: absolute;
              top: 18px;
              right: 0px;
              color: #727272;
            }
          }
        }
      }

      .line {
        border: 1px solid #000000;
      }

      .box-select {
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-align: right;
        color: #5f5f5f;
        margin-top: 26px;

        .item-select {
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          justify-content: end;

          .item-select-text {
            font-weight: 800;
            font-size: 16px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }

          .item-select-qty {
            font-weight: 800;
            font-size: 16px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }
        }

        .shinhan-text {
          font-weight: 700;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #959595;
        }
      }

      .box-total {
        display: flex;
        flex-direction: row;

        font-weight: 800;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        justify-content: right;
        color: #5f5f5f;
        margin-top: 11px;
        gap: 8px;
        align-items: center;

        .sub-total {
          font-weight: 700;
          font-size: 16px;
        }

        .price-total {
          font-size: 22px;
          color: #000000;
          margin-left: 18px;
          line-height: 100%;
        }
      }

      .timer {
        display: felx;
        flex-direction: column;
        display: flex;
        gap: 6px;
        text-align: center;

        font-weight: 700;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
        margin-top: 17px;
        padding: 11px 0px;
        color: #5f5f5f;
        height: 53px;
        border-radius: 6px;
        background: #f7f7f7;

        .time-countdown {
          color: #653cd5;
        }

        .time-end {
          font-size: 12px;
          color: #959595;
          text-align: center;
        }
      }

      .btn {
        height: 38px;
        border-radius: 6px;
        background: #653cd5;

        font-weight: 800;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        margin-top: 8px;
        color: #ffffff;
        cursor: pointer;
      }

      .btn.disabled {
        background: #d9d9d9;
      }

      .info {
        font-weight: 700;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: -0.05em;
        color: #f12d2d;
        margin-top: 8px;
        text-align: right;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 17px;

    .images {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 313px;
      height: 305px;

      .main {
        background: #f2f1f0;
        border-radius: 10px;
        cursor: pointer;

        img {
          width: 313px;
          height: 305px;
          object-fit: contain;
        }
      }

      .sub {
        width: 57px;
        height: 58px;
        display: flex;
        flex-direction: row;
        gap: 7px;

        img {
          min-width: 57px;
          max-width: 57px;
          height: 58px;
          border-radius: 4px;
          cursor: pointer;
        }

        img.active {
          border: 2px solid #653cd5;
        }

        .no-img {
          min-width: 57px;
          height: 58px;
          border-radius: 4px;
          background: #f2f1f0;
        }
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      width: 300px;

      .content {
        .title {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          letter-spacing: -0.05em;
          height: 48px;
        }

        .price {
          padding-top: 20px;
          padding-bottom: 20px;
          display: flex;
          flex-direction: column;
          gap: 14px;
          height: 148px;

          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            font-weight: 700;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: -0.05em;
            align-items: center;

            .key {
              color: #5f5f5f;
            }

            .all-value {
              font-weight: 800;
              font-size: 14px;

              span {
                color: #653cd5;
              }
            }
          }

          .item-all {
            position: relative;

            .data {
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              font-weight: 700;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;

              .key {
                color: #5f5f5f;
              }

              .all-value {
                font-weight: 800;
                font-size: 16px;

                span {
                  color: #653cd5;
                }
              }
            }

            .all {
              font-weight: 400;
              font-size: 10px;
              position: absolute;
              top: 12px;
              right: 0px;
              color: #727272;
            }
          }
        }
      }

      .line {
        border: 1px solid #000000;
      }

      .box-select {
        display: flex;
        flex-direction: column;
        gap: 3px;
        text-align: right;
        color: #5f5f5f;
        margin-top: 16px;

        .item-select {
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          justify-content: end;

          .item-select-text {
            font-weight: 800;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }

          .item-select-qty {
            font-weight: 800;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }
        }

        .shinhan-text {
          font-weight: 700;
          font-size: 10px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #959595;
        }
      }

      .box-total {
        display: flex;
        flex-direction: row;

        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        justify-content: right;
        color: #5f5f5f;
        margin-top: 10px;
        gap: 7px;
        align-items: center;

        .sub-total {
          font-weight: 700;
          font-size: 12px;
        }

        .price-total {
          font-size: 20px;
          color: #000000;
          margin-left: 15px;
          line-height: 100%;
        }
      }

      .timer {
        display: felx;
        flex-direction: column;
        display: flex;
        gap: 3px;
        text-align: center;
        font-weight: 800;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: -0.05em;
        margin-top: 16px;
        padding: 7px 0px;
        color: #5f5f5f;
        border-radius: 4px;
        background: #f7f7f7;

        .time-countdown {
          color: #653cd5;
        }

        .time-end {
          font-size: 10px;
          color: #959595;
          text-align: center;
        }
      }

      .btn {
        height: 30px;
        border-radius: 4px;
        background: #653cd5;
        font-weight: 800;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        margin-top: 6px;
        color: #ffffff;
        cursor: pointer;
      }

      .btn.disabled {
        background: #d9d9d9;
      }

      .info {
        font-weight: 700;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: -0.05em;
        color: #f12d2d;
        margin-top: 6px;
        text-align: right;
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .images {
      display: flex;
      flex-direction: column;
      gap: 10px;
      height: 619px;
      margin: 0 auto;

      .main {
        background: #f2f1f0;
        border-radius: 16px;
        width: 516px;
        height: 507px;

        img {
          width: 516px;
          height: 507px;
          object-fit: contain;
        }
      }

      .sub {
        width: 94px;
        height: 98px;
        display: flex;
        flex-direction: row;
        gap: 11px;

        img {
          min-width: 94px;
          max-width: 94px;
          height: 98px;
          border-radius: 6px;
          cursor: pointer;
        }

        img.active {
          border: 2px solid #653cd5;
        }

        .no-img {
          min-width: 94px;
          height: 94px;
          border-radius: 6px;
          background: #f2f1f0;
        }
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      margin-top: 50px;

      .content {
        .title {
          font-weight: 700;
          font-size: 28px;
          line-height: 40px;
          letter-spacing: -0.05em;
        }

        .price {
          padding-top: 48px;
          padding-bottom: 34px;
          display: flex;
          flex-direction: column;
          gap: 26px;

          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            font-weight: 700;
            font-size: 24px;
            line-height: 100%;
            letter-spacing: -0.05em;
            align-items: center;

            .key {
              color: #5f5f5f;
            }

            .all-value {
              font-weight: 800;
              font-size: 26px;

              span {
                color: #653cd5;
              }
            }
          }

          .item-all {
            position: relative;

            .data {
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              font-weight: 700;
              font-size: 24px;
              line-height: 100%;
              letter-spacing: -0.05em;

              .key {
                color: #5f5f5f;
              }

              .all-value {
                font-weight: 800;
                font-size: 26px;

                span {
                  color: #653cd5;
                }
              }
            }

            .all {
              font-weight: 400;
              font-size: 16px;
              position: absolute;
              top: 20px;
              right: 0px;
              color: #727272;
            }
          }
        }
      }

      .line {
        border: 1px solid #000000;
      }

      .box-select {
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-align: right;
        color: #5f5f5f;
        margin-top: 32px;

        .item-select {
          display: flex;
          flex-direction: row;
          gap: 14px;
          align-items: center;
          justify-content: end;

          .item-select-text {
            font-weight: 800;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }

          .item-select-qty {
            font-weight: 800;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }
        }

        .shinhan-text {
          font-weight: 700;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #959595;
        }
      }

      .box-total {
        display: flex;
        flex-direction: row;

        font-weight: 800;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: -0.05em;
        justify-content: right;
        color: #5f5f5f;
        margin-top: 16px;
        gap: 10px;
        align-items: center;

        .sub-total {
          font-weight: 700;
          font-size: 22px;
        }

        .price-total {
          font-size: 32px;
          color: #000000;
          margin-left: 30px;
          line-height: 100%;
        }
      }

      .timer {
        display: felx;
        flex-direction: column;
        display: flex;
        gap: 2px;
        text-align: center;

        font-weight: 800;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: -0.05em;
        margin-top: 42px;
        padding: 15px 50px;
        color: #5f5f5f;
        border-radius: 4px;
        background: #f7f7f7;

        .time-countdown {
          color: #653cd5;
        }

        .time-end {
          font-size: 16px;
          color: #959595;
          text-align: center;
        }
      }

      .btn {
        height: 52px;
        border-radius: 7px;
        background: #653cd5;
        font-weight: 800;
        font-size: 22px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        margin-top: 12px;
        color: #ffffff;
        cursor: pointer;
      }

      .btn.disabled {
        background: #d9d9d9;
      }

      .info {
        font-weight: 700;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        color: #f12d2d;
        margin-top: 12px;
        text-align: right;
      }
    }
  }

  @media (max-width: 567px) {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .images {
      display: flex;
      flex-direction: column;
      gap: 11px;
      height: 387px;
      margin: 0 auto;

      .main {
        background: #f2f1f0;
        border-radius: 16px;
        width: 325px;
        height: 316px;

        img {
          width: 325px;
          height: 316px;
          object-fit: contain;
        }
      }

      .sub {
        width: 59px;
        height: 60px;
        display: flex;
        flex-direction: row;
        gap: 7px;

        img {
          min-width: 59px;
          max-width: 59px;
          height: 60px;
          border-radius: 4px;
          cursor: pointer;
        }

        img.active {
          border: 2px solid #653cd5;
        }

        .no-img {
          min-width: 59px;
          height: 59px;
          border-radius: 4px;
          background: #f2f1f0;
        }
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      margin-top: 40px;

      .content {
        .title {
          font-weight: 700;
          font-size: 22px;
          line-height: 29px;
          letter-spacing: -0.05em;
        }

        .price {
          padding-top: 30px;
          padding-bottom: 24px;
          display: flex;
          flex-direction: column;
          gap: 22px;

          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            letter-spacing: -0.05em;
            align-items: center;

            .key {
              color: #5f5f5f;
            }

            .all-value {
              font-weight: 800;
              font-size: 22px;

              span {
                color: #653cd5;
              }
            }
          }

          .item-all {
            position: relative;

            .data {
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              font-weight: 700;
              font-size: 16px;
              line-height: 100%;
              letter-spacing: -0.05em;

              .key {
                color: #5f5f5f;
              }

              .all-value {
                font-weight: 800;
                font-size: 22px;

                span {
                  color: #653cd5;
                }
              }
            }

            .all {
              font-weight: 400;
              font-size: 14px;
              position: absolute;
              top: 13px;
              right: 0px;
              color: #727272;
            }
          }
        }
      }

      .line {
        border: 1px solid #000000;
      }

      .box-select {
        display: flex;
        flex-direction: column;
        gap: 2px;
        text-align: right;
        color: #5f5f5f;
        margin-top: 20px;

        .item-select {
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          justify-content: end;

          .item-select-text {
            font-weight: 800;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }

          .item-select-qty {
            font-weight: 800;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -0.05em;
            color: #5f5f5f;
          }
        }

        .shinhan-text {
          font-weight: 700;
          font-size: 12px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #959595;
        }
      }

      .box-total {
        display: flex;
        flex-direction: row;

        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        justify-content: right;
        color: #5f5f5f;
        margin-top: 10px;
        gap: 8px;
        align-items: center;

        .sub-total {
          font-weight: 700;
          font-size: 14px;
        }

        .price-total {
          font-size: 20px;
          color: #000000;
          margin-left: 11px;
          line-height: 100%;
        }
      }

      .timer {
        display: felx;
        flex-direction: column;
        display: flex;
        gap: 4px;
        text-align: center;

        font-weight: 800;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
        margin-top: 30px;
        padding: 10px 20px;
        color: #5f5f5f;
        border-radius: 4px;
        background: #f7f7f7;

        .time-countdown {
          color: #653cd5;
        }

        .time-end {
          font-size: 12px;
          color: #959595;
          text-align: center;
        }
      }

      .btn {
        height: 38px;
        border-radius: 5px;
        background: #653cd5;

        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        text-align: center;
        align-content: center;
        margin-top: 7px;
        color: #ffffff;
        cursor: pointer;
      }

      .btn.disabled {
        background: #d9d9d9;
      }

      .info {
        font-weight: 700;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: -0.05em;
        color: #f12d2d;
        margin-top: 9px;
        text-align: right;
      }
    }
  }
`;
